export const ADD_COMMITTEE_MEMBER = 'dissertationInfo/ADD_COMMITTEE_MEMBER';
export const COMPLETE_STEP = 'dissertationInfo/COMPLETE_STEP';
export const DEGREE_CHANGED = 'dissertationInfo/DEGREE_CHANGED';
export const DEPARTMENT_CHANGED = 'dissertationInfo/DEPARTMENT_CHANGED';
export const FIELD_BLURRED = 'dissertationInfo/DISSERTATION_INFO_FIELD_BLURRED';
export const FIELD_CHANGED = 'dissertationInfo/FIELD_CHANGED';
export const INIT_DATA_LOADED =
  'dissertationInfo/DISSERTATION_INFO_DATA_LOADED';
export const LANGUAGE_CHANGED = 'dissertationInfo/LANGUAGE_CHANGED';
export const LICENSE_TYPE_CHANGED = 'dissertationInfo/LICENSE_TYPE_CHANGED';
export const LOCAL_STORAGE_LOADED = 'dissertationInfo/LOCAL_STORAGE_LOADED';
export const LOCAL_STORAGE_SYNCED = 'dissertationInfo/LOCAL_STORAGE_SYNCED';
export const PRIMARY_CATEGORY_CHANGED =
  'dissertationInfo/PRIMARY_CATEGORY_CHANGED';
export const SECONDARY_CATEGORY_CHANGED =
  'dissertationInfo/SECONDARY_CATEGORY_CHANGED';
export const TERTIARY_CATEGORY_CHANGED =
  'dissertationInfo/TERTIARY_CATEGORY_CHANGED';

export const initDataLoaded = (degrees, departments, licenseTypes) => ({
  type: INIT_DATA_LOADED,
  degrees,
  departments,
  licenseTypes,
});

export const localStorageLoaded = data => ({
  type: LOCAL_STORAGE_LOADED,
  data,
});
export const localStorageSynced = () => ({ type: LOCAL_STORAGE_SYNCED });



// WEBPACK FOOTER //
// ./src/dissertation-info/dissertationInfoActions.js